module.exports = __webpack_public_path__ + "img/medicine-older.596b7083.png";